<template>

        <input type="checkbox" :value="val" v-model="checked" @change="onChange" />
</template>
<script>
export default {
  props:['value', "val", "label"],
  components: {},
  data() {
    return {
        checkedProxy: false
    }
  },
   computed: {
	  checked: {
      get () {
        return this.value
      },
      set (val) {
        this.checkedProxy = val
      }
    }
  },
  methods: {
    onChange: function(e) {
      this.$emit('input', this.checkedProxy)
    }
  }
};
</script>


// WEBPACK FOOTER //
// MultiSelectCheckbox.vue?6ad5f34c